import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { DiscountGroupDocumentLineItemRelation, DiscountGroupDocumentLineItemRelationSearchInput, Operator } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { DiscountGroupDocumentLineItemRelationService } from "../../services/discount-group-documentline-item-relation.service";

@Component({
  selector: 'app-discount-group-document-line-item-relation-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent
    ,
  ]
})
export class DiscountGroupDocumentLineItemRelationWidgetComponent extends NewBaseListComponent<DiscountGroupDocumentLineItemRelation> {

  discountGroupId = input<string>();

  constructor(
    discountGroupDocumentLineItemRelationService: DiscountGroupDocumentLineItemRelationService,
  ) {
    super("DiscountGroupDocumentLineItemRelation", discountGroupDocumentLineItemRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupDocumentLineItemRelationSearchInput {
    let si: DiscountGroupDocumentLineItemRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  // protected override setColumnConfig(colConfig: ColumnConfigEx): void {
  //   let documentLineItemIdentifierCol: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'documentLineItem.identifier' || (x.prop === "identifier" && x.entityType === 'DocumentLineItem'));
  //   if (documentLineItemIdentifierCol) {
  //     documentLineItemIdentifierCol.getEditComponent = () => DocumentLineItemDropDownComponent;
  //     documentLineItemIdentifierCol.editComponentCreated = async (c: DocumentLineItemDropDownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
  //       if (rowData?.documentLineItem)
  //         c.setModel(rowData.documentLineItem);
  //       else if (rowData?.documentLineItemId) {
  //         await c.loadItemByIdAndSetSelected(rowData.documentLineItemId);
  //         this.cdRef.detectChanges();
  //       }

  //       c.value.subscribe(async (x: DocumentLineItem) => {
  //         rowData.documentLineItemId = x?.id;
  //       });
  //     }
  //   }

  //   super.setColumnConfig(colConfig);
  // }

  override saveInCRUDService(rowData: DiscountGroupDocumentLineItemRelation): Promise<DiscountGroupDocumentLineItemRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }

}
